import { call, put } from 'redux-saga/effects';
import GetFileDownloadActions from '../redux/GetFileDownloadRedux';
import { api } from './api';


export function* getfiledownloadsagas(action: any): Generator<any, void, any> {
  const response = yield call(api.getFileDownload);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetFileDownloadActions.getFileDownloadSuccess(response.data));
  } else {
    yield put(GetFileDownloadActions.getFileDownloadFailure());
  }
}